module.exports = __webpack_public_path__ + "img/suit (2).68ac45fd.png";